/**
 * 注册页：用户名 + 邮箱 + 密码 + 确认密码 → 调 store.register（成功即登录）→ 回「我的」页
 * - 校验：用户名 2-50、邮箱非空、密码 ≥6、两次一致（与服务端规则对齐，减少无谓请求）
 * - 错误直显服务端 msg（email already registered / username already taken / passwords do not match）
 */
import { useState } from 'react';
import { useChartStore } from '../state/store';

export default function RegisterPage() {
  const register = useChartStore((s) => s.register);

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  const inputCls = 'w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-slate-500';

  async function onRegister() {
    const u = username.trim();
    const e = email.trim();
    if (u.length < 2 || u.length > 50) {
      setMsg('用户名需 2-50 个字符');
      return;
    }
    if (!e || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) {
      setMsg('请输入正确的邮箱');
      return;
    }
    if (password.length < 6) {
      setMsg('密码至少 6 位');
      return;
    }
    if (password !== confirm) {
      setMsg('两次输入的密码不一致');
      return;
    }
    setBusy(true);
    setMsg(null);
    try {
      await register(u, e, password, confirm);
      window.location.hash = '#/mine';
    } catch (err) {
      setMsg(err instanceof Error ? err.message : '注册失败，请稍后重试');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-col gap-3">
      <a href="#/mine" className="-mx-2 w-fit rounded px-2 py-1 text-sm text-slate-500 hover:bg-slate-200">
        ← 返回
      </a>
      <div className="rounded-lg bg-white px-4 py-3 shadow">
        <div className="font-medium text-slate-800">注册账号</div>
        <div className="mt-1 text-xs text-slate-400">注册成功后自动登录，并将命例同步到云端。</div>
        <div className="mt-3 flex flex-col gap-2">
          <input
            type="text"
            placeholder="用户名（2-50 个字符）"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className={inputCls}
          />
          <input
            type="email"
            placeholder="邮箱"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
          />
          <input
            type="password"
            placeholder="密码（至少 6 位）"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
          />
          <input
            type="password"
            placeholder="确认密码"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className={inputCls}
          />
          <button
            type="button"
            onClick={() => void onRegister()}
            disabled={busy}
            className="rounded-md bg-slate-800 px-3 py-2 text-sm font-medium text-white hover:bg-slate-700 disabled:opacity-40"
          >
            {busy ? '注册中…' : '注册并登录'}
          </button>
          <div className="text-xs text-slate-400">
            已有账号？
            <a href="#/mine" className="ml-1 text-slate-600 hover:text-slate-900">
              去登录
            </a>
          </div>
        </div>
        {msg && <div className="mt-2 text-xs text-red-500">{msg}</div>}
      </div>
    </div>
  );
}
